import React from "react";
import Loader from "react-js-loader";

const PageLoader = ({top, bottom}) => {

    const styles = {
        wrap: {
            paddingTop: top,
            paddingBottom: bottom,
            textAlign:'center'
        },
        loader: {
           
        }
    }

    return (
        <div style={styles.wrap}>
          <Loader type="spinner-default" bgColor = "#009900" size={50} styles = {styles.loader} />
        </div>
    )

};

export default PageLoader;